import { Moment } from 'moment'

import { BaseModel } from './base.model'
import { Program } from './program.model'

export class ApiKey extends BaseModel<ApiKey> {
  static DEFAULT_ATTRIBUTES = {}

  uuid: string
  centerId: number
  centerName: string
  deviceId: number
  deviceUid: string
  deviceNumber: string
  id: number
  userFullname: string
  userId: number
  status: string

  get captionChangeState(): string {
    if (this.status == 'activated'){
      return 'Остановить'
    }
    else if (this.status == 'pending'){
      return 'Восстановить'
    }
    else { return "" }

  }

  get isAwaiting(): boolean {
    return this.status == 'awaiting'
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/api-key.model.ts